/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UpdateStockupItemRequestStockupItem } from './UpdateStockupItemRequestStockupItem';
import {
    UpdateStockupItemRequestStockupItemFromJSON,
    UpdateStockupItemRequestStockupItemFromJSONTyped,
    UpdateStockupItemRequestStockupItemToJSON,
} from './UpdateStockupItemRequestStockupItem';

/**
 * 
 * @export
 * @interface UpdateStockupItemRequest
 */
export interface UpdateStockupItemRequest {
    /**
     * 
     * @type {UpdateStockupItemRequestStockupItem}
     * @memberof UpdateStockupItemRequest
     */
    stockupItem: UpdateStockupItemRequestStockupItem;
}

/**
 * Check if a given object implements the UpdateStockupItemRequest interface.
 */
export function instanceOfUpdateStockupItemRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "stockupItem" in value;

    return isInstance;
}

export function UpdateStockupItemRequestFromJSON(json: any): UpdateStockupItemRequest {
    return UpdateStockupItemRequestFromJSONTyped(json, false);
}

export function UpdateStockupItemRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateStockupItemRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stockupItem': UpdateStockupItemRequestStockupItemFromJSON(json['stockup_item']),
    };
}

export function UpdateStockupItemRequestToJSON(value?: UpdateStockupItemRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stockup_item': UpdateStockupItemRequestStockupItemToJSON(value.stockupItem),
    };
}

